import React, { useEffect, useState } from "react";

import { apiGet, apiPost, apiPut } from "helpers/api";
import { withCookies } from "react-cookie";
import { Button, Form, Input, Select } from "antd";

function AddSubTopicForm({ cookies, editing = null }) {
    const [form] = Form.useForm();
    const [topics, setTopics] = useState([]);
    const [csrfToken] = useState(cookies.get("XSRF-TOKEN"));

    useEffect(() => {
        if (editing) {
            apiGet(
                "/api/subtopic?subtopic=" + encodeURIComponent(editing),
                (body) => {
                    form.setFieldsValue({
                        subtopic: body.value,
                        topic: body.parent
                    });
                }
            );
        }
    }, [editing, form]);

    useEffect(
        () =>
            apiGet("/api/topics", (body) => {
                setTopics(
                    body.map((ta) => ({ label: ta.value, value: ta.value }))
                );
                if (!editing) {
                    form.setFieldsValue({ topic: body[0].value });
                }
            }),
        [editing, form]
    );

    function onSubmit(formData) {
        if (!editing) {
            apiPost("/api/add-subtopic", JSON.stringify(formData), csrfToken);
        } else {
            apiPut(
                "/api/update-subtopic?originalName=" +
                    encodeURIComponent(editing),
                JSON.stringify(formData),
                csrfToken
            );
        }
    }

    return (
        <Form form={form} onFinish={onSubmit}>
            <Form.Item name="subtopic" label={"Sub Topic"}>
                <Input required placeholder="E.g. Dividing Fractions" />
            </Form.Item>
            <Form.Item name="topic" label={"Topic"}>
                <Select>
                    {topics.map((ta) => (
                        <Select.Option key={ta.value} value={ta.value}>
                            {ta.label}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item>
                <Button key="submit" type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    );
}

export default withCookies(AddSubTopicForm);
